import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { SelectDateComponent } from './select-date.component';
import { MondayDateAdapter } from './monday-date-adapter.service';

import {
  DlDateTimeDateModule,
  DlDateTimePickerModule,
} from 'angular-bootstrap-datetimepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatDatepickerModule } from '@angular/material/datepicker';

import { MatNativeDateModule, DateAdapter } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';

import { MatInputModule } from '@angular/material/input';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatIconModule } from '@angular/material/icon';

import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@NgModule({
  declarations: [SelectDateComponent],
  entryComponents: [SelectDateComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    MatDatepickerModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatIconModule,
    PopoverModule.forRoot(),
  ],
  exports: [
    SelectDateComponent,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  providers: [
    {
      provide: DateAdapter,
      useValue: new MondayDateAdapter(),
    },
  ],
})
export class SelectDateModule {}
